import * as React from "react";
import { WizardComponent } from "../../../../Shared/Process/WizardComponent";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Action } from "../../../Actions/Action";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { CGTAction } from "./Action/CGTAction";
import { CapitalGainsSettings } from "./Components/CaptialGainSettings";

export class CaptialGainSettingsWizard extends WizardComponent {
    constructor(props: any) {
        super(props);
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {}

    componentDidMount() {
        super.componentDidMount();
        const id = getQueryParameters()["hierarchyid"];
        CGTAction.getCGTSettings(id, (data) => {
            this.setState({
                data,
                isLoading: false,
            });
        });
        Action.getClientAccount(id);
    }

    onCancel() {
        this.onExit();
    }

    onExit() {
        const params = getQueryParameters();
        Navigator.navigateTo(Urls.get().main.PortfolioDashboard({
            hierarchyId: params["clienthierarchyid"]
        }).summary);
    }

    onSubmit() {
        CGTAction.postCGTSettings(this.state.data, (data) => {
            this.onExit();
        });
    }

    setStepperConfig() {
        this.stepperConfig = [
            {
                title: "Capital Gains Settings",
                url: Urls.get().CapitalGainsSettings,
                path: Contents.URLMap.cgt,
                canSubmit: () => this.child[0].isValid(),
                onSubmit: () => this.onSubmit(),
                component: <CapitalGainsSettings {...this.getStepProps(0)} />,
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "Capital Gains Settings";
        processProps.onSave = null;
        processProps.goBacktoFirst = true;
        processProps.needSplitHeader = null;
        return processProps;
    }
}
